
import React from "react";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { IHostWebsite } from "../../../../../services";
import { isPageVisible, pagePath } from "../../helpers";

export interface HeroProps {
    basePath: string;
    images: string[];
    website: IHostWebsite;
}

const FLOAT_SLOTS = 6;

function Hero({ website, basePath, images }: HeroProps) {

    const labels = i18nManager.Labels.home;
    const name = website.host.name ?? "";
    const titleRef = React.useRef<HTMLHeadingElement>(null);
    const floats = images.slice(0, FLOAT_SLOTS);

    // keep long host names on a single line by scaling the display type down to the available width
    React.useLayoutEffect(() => {
        const el = titleRef.current;
        if (!el) return;
        const fit = () => {
            el.style.setProperty("--fit", "1");
            const ratio = (el.parentElement?.clientWidth ?? el.scrollWidth) / el.scrollWidth;
            el.style.setProperty("--fit", `${Math.min(1, ratio)}`);
        };
        fit();
        window.addEventListener("resize", fit);
        return () => window.removeEventListener("resize", fit);
    }, [name]);

    return (<section className={styles["hero"]}>
        <div className={Classname.build(styles["container"], styles["hero-inner"])}>
            <span className={styles["tag"]}>{labels.hello}</span>
            <h1 ref={titleRef} className={styles["h-01"]}>{name}</h1>
            {website.host.short_info && (<p className={styles["hero-text"]}>{website.host.short_info}</p>)}
            <div className={styles["hero-btns"]}>
                {isPageVisible(website, "TOURNAMENTS") && (<Btn to={pagePath(basePath, "TOURNAMENTS")}>{labels.cta}</Btn>)}
                {isPageVisible(website, "ABOUT") && (<Btn variant="outline" to={pagePath(basePath, "ABOUT")}>{labels.cta_alt}</Btn>)}
            </div>
        </div>
        <div className={styles["hero-float"]} aria-hidden>
            {floats.map((src, i) => (<div key={src + i} className={Classname.build(styles["float-img"], styles[`float-${i + 1}`])}>
                <img src={src} alt="" loading="lazy" />
            </div>))}
        </div>
    </section>);
}

export default Hero;
